import { Navigate, Outlet, useSearchParams } from "react-router-dom";
import { useAuth } from "@/auth/auth-provider";

/**
 * Where to land after auth: a pending team invite, `?next=` from a guarded page, else the billing
 * intent from a marketing link.
 */
function destination(params: URLSearchParams) {
	const invite = params.get("invite");
	if (invite) return `/invite/${encodeURIComponent(invite)}?accept=1`;
	const next = params.get("next");
	if (next?.startsWith("/") && !next.startsWith("//")) return next;
	const buy = params.get("buy");
	if (buy) return `/settings/billing?buy=${encodeURIComponent(buy)}`;
	const plan = params.get("plan");
	if (plan && plan !== "free") {
		const interval = params.get("interval");
		return `/settings/billing?plan=${encodeURIComponent(plan)}${interval ? `&interval=${encodeURIComponent(interval)}` : ""}`;
	}
	return "/";
}

export function PublicRoute() {
	const { isAuthenticated } = useAuth();
	const [params] = useSearchParams();
	if (isAuthenticated) return <Navigate to={destination(params)} replace />;
	return <Outlet />;
}
